import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, FormGroup, Label, Input, Button, Alert, Row, Col, FormFeedback } from 'reactstrap';
import logo from '../../assets/images/cmmc-logo.webp'
import { decrypt } from '../../helper/requests';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { authenticate } from '../../helper/requests';
import { setAdmin } from '../../redux/userSlice';



const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (email.trim() === '') {
            setError('Email is required');
            return;
        }

        if (password.trim() === '') {
            setError('Password is required');
            return;
        }

        let access = await authenticate({email: email.trim(), password: password.trim()})
        access = decrypt(access)
        if(access && access.token){
            console.log(access)
            axios.defaults.headers.common['Authorization'] = `Bearer ${access.token}`;
            localStorage.setItem("adminAccess", JSON.stringify(access))
            dispatch(setAdmin(access))
            navigate('/admin/home')
        }else{
            setError('Incorrect email or password');
            return;
        }
    };

    useEffect(()=>{
        setError('')
    }, [email])

    return (
        <Container fluid>
            <Row>
                <Col className='xy-center' style={{minHeight: '100vh', minWidth: '100vw'}}>
                    <div className='p-4' style={{maxWidth: '400px', width: '100%', border: '1px dashed var(--primary)', borderRadius: '6px'}}>
                        <div className='text-center mb-5'>
                            <img src={logo} width='120px'/>
                        </div>
                        <Form onSubmit={handleSubmit}>
                            <FormGroup>
                                <Label for="email">Email</Label>
                                <Input
                                    type="text"
                                    name="email"
                                    id="email"
                                    placeholder="Enter email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for="password">Password</Label>
                                <Input
                                    type="password"
                                    name="password"
                                    id="password"
                                    placeholder="Enter password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <FormFeedback style={{minHeight: '21px', height: '21px', visibility: error.length ? 'visible': 'hidden', display: 'block'}}>{error}</FormFeedback>
                            </FormGroup>
                            <Button className='w-100 theme-button' style={{marginTop: '-1rem'}} type="submit">Login</Button>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;
